import { COMPLIANCE_DATA, TAGLINE_MF, TAGLINE_SIF } from "../constants/compliance";

export default function ComplianceBadge({ variant = "full" }) {
  if (variant === "minimal") {
    return (
      <div className="text-xs text-gray-400" data-testid="compliance-badge-minimal">
        <div className="font-medium">{COMPLIANCE_DATA.tradeName}</div>
        <div>ARN: {COMPLIANCE_DATA.arn}</div>
      </div>
    );
  }

  return (
    <div className="compliance-badge" data-testid="compliance-badge">
      <div className="text-sm font-semibold text-gray-200">
        {COMPLIANCE_DATA.tradeName}
      </div>
      <div className="text-sm text-[#d4af69] font-medium">
        ARN: {COMPLIANCE_DATA.arn}
      </div>
      <div className="text-xs text-gray-400 mt-1">
        {TAGLINE_MF}
      </div>
      {COMPLIANCE_DATA.sifEnabled && (
        <div className="text-xs text-gray-400">
          {TAGLINE_SIF}
        </div>
      )}
    </div>
  );
}